'use client'

import { useState, useLayoutEffect } from "react"

/**
 * A hook to get the screen size.
 *
 * @returns Object {width: width, height: height} in pixels
 */
export function useScreenSize() {
    const [size, setSize] = useState({
        width: null,
        height: null,
    })

    useLayoutEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.screen.width,
                height: window.screen.height,
            })
        }

        handleResize()
        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    return size
}
